import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { FieldErrors } from "react-hook-form";
import { journalsQueries } from "@/entities/journal";
import { useValidateTitle } from "@/features/journal-title-validation";
import { useCoordinator } from "@/shared/lib/hooks";
import { CollapsibleSection } from "../collapsible-section";
import { useSaveJournal } from "../journals-side-table/model/hooks/user-hooks/use-save-journal";
import { createValidationErrorsGetter } from "../journals-title/model/get-validation-errors-for-section";
import { ConstructionDetails } from "./ui/construction-details";
import { JournalsInfoMain } from "./ui/journals-info-main";

interface IJournalsInfoTable {
  errors: FieldErrors<{
    journalnumber: string;
  }>;
}

export const JournalsInfoTableNew = ({ errors }: IJournalsInfoTable) => {
  const { titleId } = useCoordinator();
  const { isLoading } = useQuery(journalsQueries.getTitleJournal({ titleId }));
  const { errorList } = useValidateTitle();
  const { handleSave } = useSaveJournal({ handleClear: () => {} });

  const validationErrors = useMemo(() => {
    return errorList.filter((error) => [1, 2, 3, 4].includes(error.id));
  }, [errorList]);

  const getValidationErrorsForSection = useMemo(
    () => createValidationErrorsGetter(errorList),
    [errorList],
  );

  return (
    <CollapsibleSection
      title="Информация об обьекте"
      spinning={isLoading}
      validationErrors={validationErrors}
      sectionId="journals-info"
      getValidationErrorsForSection={getValidationErrorsForSection}
      saveBeforeNext
      onSave={handleSave}
    >
      <JournalsInfoMain errors={errors} />
      <ConstructionDetails errors={errors} />
    </CollapsibleSection>
  );
};

